import { render, staticRenderFns } from "./DashboardTopTableCard.vue?vue&type=template&id=376fc44b&scoped=true&"
import script from "./DashboardTopTableCard.vue?vue&type=script&lang=js&"
export * from "./DashboardTopTableCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTopTableCard.vue?vue&type=style&index=0&id=376fc44b&lang=scss&scoped=true&"
import style1 from "./DashboardTopTableCard.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DashboardTopTableCard.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376fc44b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCardTitle: require('/workspace/components/Dashboard/DashboardCardTitle.vue').default})
